import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { IParagraphOurBrandsTeasersProps } from "./ParagraphOurBrandsTeasersProps";
import { Container } from "./ParagraphOurBrandsTeasersHelpers";
import BrandTeasers from "../../common/BrandTeasers/BrandTeasers";

const ParagraphOurBrandsTeasers: React.FC<IParagraphOurBrandsTeasersProps> = (
  props
) => {
  const data = useStaticQuery(graphql`
    {
      site: rlhsite(machine_name: { eq: "sonesta" }) {
        relationships {
          brands: field_brands {
            id
            brand_code
            name
            description {
              processed
              value
            }
            path {
              alias
            }
            field_logo_alt_text
            field_logo_alternate_alt_text
            relationships {
              field_logo {
                publicUrl
                gatsbyImage(
                  height: 250
                  width: 50
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                )
              }
              field_logo_alternate {
                publicUrl
                gatsbyImage(
                  height: 250
                  width: 50
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                )
              }
              field_teaser_image {
                relationships {
                  field_media_image {
                    publicUrl
                    gatsbyImage(
                      height: 180
                      width: 544
                      placeholder: BLURRED
                      formats: [AUTO, WEBP]
                    )
                  }
                }
              }
            }
          }
        }
      }
    }
  `);
  const brands = data.site?.relationships;
  const brandProps = { ...props.node, ...brands };
  return (
    <Container {...props}>
      <BrandTeasers {...brandProps}></BrandTeasers>
    </Container>
  );
};
export const fragment = graphql`
  fragment ParagraphOurBrandsTeasers on paragraph__our_brands_teasers {
    id
    field_title
    field_subtitle
    field_description
    parent_type
  }
`;
export default ParagraphOurBrandsTeasers;
